module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.auth) ? _c('div', [_c('navbar')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('router-view')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dfd74d46"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 302
// module chunks = 1